import { aboutus2 } from "./hu/aboutus2";
import { adminFinance } from "./hu/adminFinance";
import { brandStrategy } from "./hu/brandStrategy";
import { customerRelations } from "./hu/customerRelations";
import { dailyAssistant } from "./hu/dailyAssistant";
import { admin } from "./hu/admin";
import { affiliate } from "./hu/affiliate";
import { aiAssistant } from "./hu/aiAssistant";
import { aiAnalytics } from "./hu/aiAnalytics";
import { appointments } from "./hu/appointments";
import { asszisztensNaptar } from "./hu/asszisztensNaptar";
import { auth } from "./hu/auth";
import { bookingSystem } from "./hu/bookingSystem";
import { burjanfanni } from "./hu/burjanfanni";
import { checkout } from "./hu/checkout";
import { common } from "./hu/common";
import { components } from "./hu/components";
import { content } from "./hu/content";
import { creator } from "./hu/creator";
import { creatorWorld } from "./hu/creatorWorld";
import { customers } from "./hu/customers";
import { gaming } from "./hu/gaming";
import { interactiveData } from "./hu/interactiveData";
import { interactiveFeatures } from "./hu/interactiveFeatures";
import { landing2 } from "./hu/landing2";
import { landing4 } from "./hu/landing4";
import { landing5 } from "./hu/landing5";
import { landing6 } from "./hu/landing6";
import { landingPage } from "./hu/landingPage";
import { marketingAutomation } from "./hu/marketingAutomation";
import { media } from "./hu/media";
import { meetings } from "./hu/meetings";
import { onboarding } from "./hu/onboarding";
import { orders } from "./hu/orders";
import { partners } from "./hu/partners";
import { partnersReg } from "./hu/partnersReg";
import { personalVideo } from "./hu/personalVideo";
import { personas } from "./hu/personas";
import { pitchdeck } from "./hu/pitchdeck";
import { platformBenefits } from "./hu/platformBenefits";
import { pricing2 } from "./hu/pricing2";
import { pumpedgabo } from "./hu/pumpedgabo";
import { selection } from "./hu/selection";
import { services } from "./hu/services";
import { smbOnboarding } from "./hu/smbOnboarding";
import { smbOnboarding2 } from "./hu/smbOnboarding2";
import { szakacsgeri } from "./hu/szakacsgeri";
import { tsmtPartner } from "./hu/tsmtPartner";
import { contractors } from "./hu/contractors";
import { tsmtPitch } from "./hu/tsmtPitch";
import { tsmtPitchTherapists } from "./hu/tsmtPitchTherapists";
import { tsmtWebinar } from "./hu/tsmtWebinar";
import { tsmtKommunikacioPlaybook } from "./hu/tsmtKommunikacioPlaybook";
import { useCase } from "./hu/use-case";
import { userAdmin } from "./hu/userAdmin";
import { userAdmin3 } from "./hu/userAdmin3";
import { users } from "./hu/users";
import { websiteBuilder } from "./hu/websiteBuilder";
import { whiteLabel } from "./hu/whiteLabel";
import { aboutLanding4 } from "./hu/aboutLanding4";
import { coachWorld } from "./hu/coachWorld";
import { rounds } from "./hu/rounds";
import { socialStudio } from "./hu/socialStudio";

export const hu = {
  aboutLanding4,
  coachWorld,
  aboutus2,
  adminFinance,
  brandStrategy,
  customerRelations,
  dailyAssistant,
  admin,
  affiliate,
  aiAssistant,
  aiAnalytics,
  appointments,
  asszisztensNaptar,
  auth,
  bookingSystem,
  burjanfanni,
  checkout,
  common,
  components,
  content,
  creator,
  creatorWorld,
  customers,
  gaming,
  interactiveData,
  interactiveFeatures,
  landing2,
  landing4,
  landing5,
  landing6,
  landingPage,
  marketingAutomation,
  media,
  meetings,
  onboarding,
  orders,
  partners,
  partnersReg,
  personalVideo,
  personas,
  pitchdeck,
  platformBenefits,
  pricing2,
  pumpedgabo,
  rounds,
  selection,
  services,
  smbOnboarding,
  smbOnboarding2,
  socialStudio,
  szakacsgeri,
  tsmtPartner,
  contractors,
  tsmtPitch,
  tsmtPitchTherapists,
  tsmtWebinar,
  tsmtKommunikacioPlaybook,
  useCase,
  userAdmin,
  userAdmin3,
  users,
  websiteBuilder,
  whiteLabel,
};

export default hu;
